import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dropWindow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    width: '100%',
    borderColor: theme.palette.grey[200],
    border: 'dashed',
    borderRadius: '4px',
  },
  dragging: {
    background: theme.palette.grey[200],
  },
  notDragging: {
    background: 'none',
  },
  message: {
    textTransform: 'uppercase',
    color: theme.palette.grey[500],
  },
  icon: {
    fontSize: '50px',
    color: theme.palette.grey[400],
  },
}));

export default useStyles;
